import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Box, Link, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

// Services
import { getScopeTemplate } from '../../../services/scopetemplate.service';

// Types
import { ScopeTemplate } from '../../../types/ScopeTemplate';

// Components
import ScopeView from '../authorization/scope/scopeview';

export const EditScopeTemplate = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [scopeTemplate, setScopeTemplate] = useState<ScopeTemplate>();

  useEffect(() => {
    id &&
      getScopeTemplate(id).then((x: any) => {
        x.status === 200 && setScopeTemplate(x.data);
        // do something
      });
  }, [id]);

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', padding: '0 0.5em 0 1.5em', justifyContent: 'space-between' }}>
        <h3 style={{ display: 'flex' }}>{scopeTemplate?.name}</h3>
        <div style={{ display: 'flex' }}>
          <Link href='#' onClick={() => navigate('/scopetemplates')} underline='none' sx={{ display: 'flex' }}>
            <ArrowBack sx={{ marginRight: '4px' }} />
            <Typography variant='body1' sx={{ display: 'inline' }}>
              Back to Overview
            </Typography>
          </Link>
        </div>
      </Box>
      <Box display={'flex'} flexDirection={'column'} width={'100%'}>
        <ScopeView targetType='template' targetId={id as string} isReadOnly={false} />
      </Box>
    </>
  );
};

export default EditScopeTemplate;
